// extracted by mini-css-extract-plugin
module.exports = {"SectionB1":"SectionB1_SectionB1__vsfTA"};